export default __webpack_public_path__ + "static/media/search.a0c4f937.gif";